import { forPreview } from "../../util/printableText";
import { FOREWORD_BODY_FONT, FOREWORD_COLORS, FOREWORD_TITLE_FONT, layoutForewordPage } from "../../util/forewordPage";

/**
 * The dedication as it prints on the inside front cover: the print layout
 * (util/forewordPage.js, a port of the API's renderer) drawn as an SVG at print
 * size and scaled to the box, so the preview and the book match.
 */
const ForewordPage = ({ introKeyword, description, className }) => {
  const page = layoutForewordPage({ introKeyword, description });
  return (
    <svg
      viewBox={`0 0 ${page.width} ${page.height}`}
      preserveAspectRatio="xMidYMid meet"
      className={className}
      role="img"
      aria-label={[page.title?.text, ...page.lines.map((l) => l.text)].filter(Boolean).join(" ")}
    >
      <rect x="0" y="0" width={page.width} height={page.height} fill="#FFFFFF" />
      <rect
        x={page.frame.x}
        y={page.frame.y}
        width={page.frame.width}
        height={page.frame.height}
        fill="none"
        stroke={FOREWORD_COLORS.frameStroke}
        strokeWidth="1.5"
      />
      {page.title ? (
        <text
          x="50%"
          y={page.title.y}
          fontFamily={FOREWORD_TITLE_FONT}
          fontSize={page.titleSize}
          fontWeight="400"
          fill={FOREWORD_COLORS.darkCocoa}
          textAnchor="middle"
          letterSpacing="0.02em"
        >
          {forPreview(page.title.text)}
        </text>
      ) : null}
      {page.dividers.map((d) => (
        <rect key={d.y} x={d.x} y={d.y} width={d.width} height={d.height} fill={FOREWORD_COLORS.deepHoney} />
      ))}
      <text fontFamily={FOREWORD_BODY_FONT} fontSize={page.bodySize} fontWeight="400" fill={FOREWORD_COLORS.warmSienna} textAnchor="middle">
        {page.lines.map((line, i) => (
          <tspan key={i} x="50%" y={line.y}>
            {forPreview(line.text)}
          </tspan>
        ))}
      </text>
    </svg>
  );
};

export default ForewordPage;
